import { FetchResult, gql } from 'apollo-boost';
import { IPipOption } from '../../../models/pip-option';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query {
        pip_options {
            uid,
            name,
            earnOptionId: earn_option_id,
            amount,
            description,
        }
    }
`;

export async function getAllPipOptions(): Promise<IPipOption[]> {
    const result: FetchResult<{ pip_options: IPipOption[] }> = await graphqlClient.query({
        query: QUERY,
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.pip_options;
}
